"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal } from "@/shared/ui/templates";
import { NaverMap } from "@/shared/ui/organisms";
interface HospitalMapViewerModalProps {
  open: boolean;
  onClose: () => void;
  location: {
    latitude: number;
    longitude: number;
  };
}
const HospitalMapViewerModal = t0 => {
  const $ = _c(6);
  const {
    open,
    onClose,
    location
  } = t0;
  let t1;
  if ($[0] !== location) {
    t1 = <div className="h-full w-full bg-white"><NaverMap location={location} width="100%" height="100%" draggable={true} zoomControl={true} pinchZoom={true} scrollWheel={true} disableDoubleClickZoom={false} disableDoubleTapZoom={false} disableTwoFingerTapZoom={false} /></div>;
    $[0] = location;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== open || $[4] !== t1) {
    t2 = <Modal open={open} onClose={onClose} height="screen" round="0px" headerMarginBottomClassName="mb-4">{t1}</Modal>;
    $[2] = onClose;
    $[3] = open;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default HospitalMapViewerModal;